import { useQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { retryUnlessClientError } from '~/shared/lib/api-error'
import { GOLD_SET_QUERY_KEYS } from '../config'
import type { GoldSetQueue } from '../model'

export function useGoldSetQueue(pass: number) {
  return useQuery({
    queryKey: GOLD_SET_QUERY_KEYS.queue(pass),
    queryFn: async () => {
      const response = await apiClient.client.get({
        url: '/gold-set/queue',
        query: { pass },
        throwOnError: true,
      })
      return response.data as GoldSetQueue
    },
    retry: retryUnlessClientError,
  })
}
